import classNames from 'classnames'
import { useNavigate } from 'react-router-dom'
interface IFooterItemsProps {
    icon: string | undefined
    isActive: boolean
    title: string
    router: string
    role: string
    activeIcon: string
}

const Items = ({
    icon,
    isActive,
    title,
    router,
    role,
    activeIcon,
}: IFooterItemsProps) => {
    const navigate = useNavigate()
    return (
        <div
            onClick={() => navigate(router)}
            className="m-auto flex flex-col items-center text-center cursor-pointer select-none active:scale-95"
        >
            <div
                className={classNames(
                    'flex items-center justify-center w-12 h-8 rounded-2xl transition-colors duration-200',
                    isActive ? 'bg-green-2' : 'bg-transparent'
                )}
            >
                <img
                    src={isActive ? activeIcon : icon}
                    alt={title}
                    className="w-6 h-6"
                />
            </div>
            <small
                className={classNames(
                    'mt-1 text-center text-[11px]',
                    isActive
                        ? 'text-green-1 font-bold'
                        : 'text-gray-2 font-semibold'
                )}
            >
                {title}
            </small>
        </div>
    )
}

export default Items
